import { all } from "redux-saga/effects";
import { hinhThucSaga } from "./hinhThucSaga";
import { hinhThucChiTietSaga } from "./hinhThucChiTietSaga";
import { hinhThucTinhSaga } from "./hinhThucTinhSaga";
import { danhSachMienGiamSaga } from "./danhSachMienGiamSaga";
import { mienGiamSoTienSaga } from "./mienGiamSoTienSaga";


export default function* mienGiamSaga() {
  yield all([
    hinhThucSaga(),
    hinhThucChiTietSaga(),
    hinhThucTinhSaga(),
    danhSachMienGiamSaga(),
    mienGiamSoTienSaga(),
  ]);
}
